import {Injectable} from '@angular/core';
import {ParametroPortalService} from '../../../services/parametro-portal.service';
import {isNullOrUndefined} from 'util';
import {ParametrosOcultoEnum, ParametrosPortalEnum} from '../../../enums/parametros.enum';

@Injectable({
  providedIn: 'root'
})
export class ParamEspecificoLocalStorageService {


  constructor(
    private parametroPortalService: ParametroPortalService,
  ) {
  }


  /**
   * Consultas em andamento por parâmetro: chamadas simultâneas (ex.: uma por marker ao agrupar)
   * aguardam a mesma requisição em vez de cada uma disparar a sua.
   */
  private consultasEmAndamento = new Map<string, Promise<any>>();

  /** Parâmetros que o servidor informou não existirem, para não consultá-los novamente a cada marker. */
  private parametrosInexistentes = new Set<string>();

  async getParametroEspecificoLocalStorage(parametroNome: string) {
    const param = sessionStorage.getItem(parametroNome);
    // Valor vazio também é um valor em cache (antes um parâmetro vazio era consultado no servidor a cada chamada)
    if (param !== null) {
      return param;
    }
    if (this.parametrosInexistentes.has(parametroNome)) {
      return null;
    }

    let consulta = this.consultasEmAndamento.get(parametroNome);
    if (!consulta) {
      consulta = this.consultarParametro(parametroNome);
      this.consultasEmAndamento.set(parametroNome, consulta);
      const finalizar = () => this.consultasEmAndamento.delete(parametroNome);
      consulta.then(finalizar, finalizar);
    }
    return consulta;
  }

  private async consultarParametro(parametroNome: string): Promise<any> {
    const parametros = await this.parametroPortalService.obterListaParametros(
      [parametroNome]).toPromise();
    if (isNullOrUndefined(parametroNome) || parametros.length === 0) {
      this.parametrosInexistentes.add(parametroNome);
      return null;
    }
    sessionStorage.setItem(parametroNome, parametros[0].valor);
    return parametros[0].valor;
  }

  async salvarParametroEspecificoLocalStorage(parametroNome: ParametrosPortalEnum | ParametrosOcultoEnum) {
    const parametro = await this.parametroPortalService.obterParametroEspecifico(
      {id: parametroNome}).toPromise();
    if (!isNullOrUndefined(parametro)) {
      sessionStorage.setItem(parametroNome, parametro.valor);
    }
  }

  async salvarListaParametroLocalStorage(parametrosNome: string[]) {

    const parametro = await this.parametroPortalService.obterListaParametros(
      parametrosNome).toPromise();

    parametro.forEach(param => {
      sessionStorage.setItem(param.id, param.valor);
    });
  }


  async atualizarParametroEspecificoLocalStorage(...parametroNome: string[]) {
    const parametros = await this.parametroPortalService.obterListaParametros(
      parametroNome).toPromise();

    if (parametros == null || parametros.length === 0) {
      return;
    }
    parametroNome.forEach(paramNome => {
      const param = parametros.find(p => p.id === paramNome);
      if (param) {
        sessionStorage.setItem(paramNome, param.valor);
      }
    });
  }

}


